import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "swatch", "nativePicker", "customPreview"]

  connect() {
    this.updateSelection()
  }

  select(event) {
    const color = event.currentTarget.dataset.color
    this.inputTarget.value = color
    if (this.hasNativePickerTarget) {
      this.nativePickerTarget.value = color
    }
    this.updateSelection()
  }

  onNativeInput(event) {
    const color = event.target.value
    this.inputTarget.value = color
    this.updateSelection()
  }

  updateSelection() {
    const currentColor = this.inputTarget.value?.toLowerCase()
    const presetColors = this.swatchTargets.map(s => s.dataset.color?.toLowerCase())
    const isCustomColor = currentColor && !presetColors.includes(currentColor)

    // Update swatch selection states
    this.swatchTargets.forEach(swatch => {
      const swatchColor = swatch.dataset.color?.toLowerCase()
      const isSelected = swatchColor === currentColor

      if (isSelected) {
        swatch.classList.add('ring-2', 'ring-offset-2', 'ring-brown-600')
        swatch.querySelector('.check-icon')?.classList.remove('hidden')
      } else {
        swatch.classList.remove('ring-2', 'ring-offset-2', 'ring-brown-600')
        swatch.querySelector('.check-icon')?.classList.add('hidden')
      }
    })

    // Update custom preview
    if (this.hasCustomPreviewTarget) {
      if (isCustomColor && currentColor) {
        // Show the custom color
        this.customPreviewTarget.style.background = currentColor
        this.customPreviewTarget.classList.add('ring-2', 'ring-offset-2', 'ring-brown-600')
        this.customPreviewTarget.innerHTML = `
          <svg class="w-4 h-4 text-white drop-shadow" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        `
      } else {
        // Show the color wheel gradient
        this.customPreviewTarget.style.background = 'conic-gradient(from 0deg, #ef4444, #f59e0b, #22c55e, #3b82f6, #8b5cf6, #ef4444)'
        this.customPreviewTarget.classList.remove('ring-2', 'ring-offset-2', 'ring-brown-600')
        this.customPreviewTarget.innerHTML = `
          <svg class="w-4 h-4 text-white drop-shadow" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
        `
      }
    }

    // Keep native picker in sync
    if (this.hasNativePickerTarget && currentColor) {
      this.nativePickerTarget.value = currentColor
    }
  }
}
